// extracted by mini-css-extract-plugin
export default {"modalTitle":"modalTitle-KnvvX","modalText":"modalText-VOyc2"};